import { WEB_COMPONENT_SENSOR_GOOGLE_WORKSPACE } from '../../../webcomponents.constants';
import { GoogleWorkspaceSensorComponent } from './component/GoogleWorkspaceSensorComponent';

export { GoogleWorkspaceSensorComponent };
window.customElements.define(WEB_COMPONENT_SENSOR_GOOGLE_WORKSPACE, GoogleWorkspaceSensorComponent);
